/*
* @Author: Jsonzhang0215
* @Date:   2018-04-04 16:57:30
 * @Last Modified by: Jason
 * @Last Modified time: 2018-07-12 14:07:40
*/
let env = process.env.NODE_ENV;
// let host = location.host;

let fileUpload = '//10.20.1.181/pfile-server/upload'; // 开发测试地址

// 编译发布的地址
if (env === 'production') {
    // 测试域名
    // if (host === 'v4testweb.dangjianwang.com') {
    //     fileUpload = 'https://v4testfile.dangjianwang.com'
    // } else {
    //     // 其他正式环境
    //     if (host.indexOf('dangjianwang.com') !== -1 || host.indexOf('zhibugongzuo.com') !== -1) {
    //         fileUpload = 'https://file.dangjianwang.com'
    //     }
    // }
    fileUpload = '{{FILE_UPLOAD}}'
}

const config = {
    baiduKey: '7ni9Z3mbo6SQG1OgrzPxNBUWWhnnXxVP',
    uploadUrl: '/ucenter/file/uptoken', // 文件上传获取 token地址
    upload: fileUpload, // 文件上传地址
    install: function (Vue, options) {
        Vue.prototype.$config = config
    }
}
export default config



// WEBPACK FOOTER //
// ./src/lib/config.js